// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2FJB1","resendInfoText":"OnGoingPaymentBox_resendInfoText__2eQrq"};